import DepartmentTable from "../components/Department/DepartmentTable";

const Department = () => {
    return (
        <div className="container">
            <DepartmentTable />
        </div>
    );
};

export default Department;
